<template>
    <div>
        <ol class="breadcrumb float-xl-end">
            <li class="breadcrumb-item"><a href="javascript:;">Lealtad</a></li>
            <li class="breadcrumb-item active">Estrateca</li>
            <li class="breadcrumb-item active">Aumento de saldo</li>
        </ol>

        <h1 class="page-header">
            Aumento de saldo
        </h1>

        <div class="row">
            <div class="col-md-8">
                <form>
                    <div class="form-group row">
                        <div class="col-md-3" style="padding-top: 2.65em;">
                            <button type="button" @click="search" class=" btn btn-success me-1 mb-1
                                pull-right">Buscar</button>
                        </div>
                        <div class="col-md-3" style="padding-top: 2.65em;">
                            <div class="col-md-5">
                                <button type="button" class="btn btn-primary w-100px me-5px" @click="openModalVisor"
                                    :disabled="loading">
                                    <span v-if="loading">
                                        <i class="fas fa-spinner fa-spin"></i> Cargando...
                                    </span>
                                    <span v-else>Agregar</span>
                                </button>

                            </div>
                        </div>
                    </div>
                </form>
            </div>

        </div>

        <DxDataGrid id="gridContainer" :data-source="ReporteGetAccruals" key-expr="Transaccion" :show-borders="true"
            @exporting="onExporting" :show-column-lines="true" :show-row-lines="true" :row-alternation-enabled="true"
            :column-min-width="50" :allow-column-resizing="true" :column-auto-width="true" :column-width="120">

            <DxScrolling column-rendering-mode="virtual" />
            <DxPager :show-page-size-selector="true" :allowed-page-sizes="[10, 20, 50, 100]"
                :show-navigation-buttons="true" />
            <DxPaging :page-size="10" :page-index="1" />
            <DxFilterRow />
            <DxHeaderFilter :visible="true" />
            <DxSearchPanel :visible="true" :width="240" placeholder="Buscar..." />

            <DxGroupPanel :visible="true" />
            <DxGrouping :auto-expand-all="true" />
            <DxExport :enabled="true" :allow-export-selected-data="false" />
            <DxSelection mode="none" />

            <DxColumn data-field="Transaccion" caption="Transacción" :width="180" />
            <DxColumn data-field="Fecha" caption="Fecha" :width="160" dataType="datetime" format="dd/MM/yyyy" />
            <DxColumn data-field="Total" caption="Total" data-type="number">
                <DxFormat type="currency" :precision="2" />
            </DxColumn>
            <DxColumn data-field="Cantidad" caption="Cantidad" data-type="number" />
            <DxColumn data-field="AccrualPoints" caption="Puntos" data-type="number" />
            <DxColumn data-field="Balance" caption="Saldo actual" data-type="number" />
            <DxColumn data-field="PreviousBalance" caption="Saldo previo" data-type="number" />
            <DxColumn data-field="CardNumber" caption="CardNumber" :width="200" />
            <DxColumn data-field="Usuario" caption="Usuario" :width="180" />
            <DxColumn data-field="Estacion" caption="Estación" :width="120" />
            <DxColumn data-field="FechaRegistro" caption="Fecha Registro" :width="160" dataType="datetime"
                format="dd/MM/yyyy" />
            <DxColumn data-field="BrandId" caption="Brand Id" :width="120" />
            <DxColumn data-field="ProgramId" caption="Program Id" :width="120" />

        </DxDataGrid>

        <b-modal id="modalDialogVisor" size="xl" centered cancel-variant="default">
            <template slot="modal-header">
                <h4 class="modal-title">Agregar Saldo</h4>
                <a class="btn-close" @click="$bvModal.hide('modalDialogVisor')"></a>
            </template>
            <div class="card">
                <div class="row">
                    <div class="col-xl-8">
                        <panel title="Cliente" bodyClass="p-0">
                            <form class="form-horizontal form-control form-container p-5">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label class="col-md col-form-label">Card Number</label>
                                        <input class="form-control" type="number" v-model="Cardnumber">
                                    </div>

                                    <div class="col-md-6">
                                        <label class="col-md col-form-label">Empresa</label>
                                        <select class="form-select" name="" id="" v-model="EmpresaSeleccionada">
                                            <option :value="empresa" v-for="empresa in Empresas" :key="empresa">
                                                {{ empresa.Nombre }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label class="col-md col-form-label">Program ID</label>
                                        <input class="form-control" type="number" v-model="ProgramID" readonly>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="col-md col-form-label">Brand ID</label>
                                        <input class="form-control" type="number" v-model="BrandID" readonly>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md col-form-label"></label>
                                    <div class="col-md-8 btnBuscar">
                                        <button type="button" class="btn btn-primary w-100px me-5px"
                                            @click="GetCardNumberInfo" :disabled="loading">
                                            <span v-if="loading">
                                                <i class="fas fa-spinner fa-spin"></i> Cargando...
                                            </span>
                                            <span v-else>Buscar</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label class="col-md col-form-label">Cliente</label>
                                        <input class="form-control text-center" type="text" v-model="MemberInfo.Cliente"
                                            readonly>
                                    </div>

                                    <div class="col-md-6">
                                        <label class="col-md col-form-label">Puntos</label>
                                        <input class="form-control text-center" type="number"
                                            v-model="MemberInfo.CurrentBalance" readonly>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label class="col-md col-form-label">Productos</label>
                                        <input class="form-control text-center" type="text"
                                            v-model="MemberInfo.Producto" readonly>
                                    </div>

                                    <div class="col-md-6">
                                        <label class="col-md col-form-label">Litros Ganados</label>
                                        <input class="form-control text-center" type="number"
                                            v-model="MemberInfo.ProductCredit" readonly>
                                    </div>
                                </div>
                            </form>
                        </panel>
                    </div>

                    <div class="col-xl-4">
                        <panel title="Ticket" bodyClass="p-0">
                            <form class="form-horizontal form-control p-5">
                                <div class="form-group row">
                                    <div class="col-md">
                                        <label class="col-md col-form-label">Estación</label>
                                        <input class="form-control" type="text" v-model="Estacion" readonly>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md">
                                        <label class="col-md col-form-label">Producto</label>
                                        <select class="form-select" name="" id="" v-model="ProductosSelect">
                                            <option :value="producto" v-for="producto in Productos" :key="producto">
                                                {{ producto.Nombre }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md">
                                        <label class="col-md col-form-label">Cantidad</label>
                                        <input class="form-control" type="number" v-model="Cantidad"
                                            @change="CalcularTotal" @blur="formatTotal">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md">
                                        <label class="col-md col-form-label">Precio</label>
                                        <input class="form-control" type="number" v-model="Precio"
                                            @change="CalcularTotal">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md">
                                        <label class="col-md col-form-label">Total</label>
                                        <input class="form-control text-left" type="text" prefix="$" v-model="Total"
                                            readonly>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md btnBuscar">
                                        <button type="button" class="btn btn-primary w-100px me-5px"
                                            @click="SetAumentoSaldo" :disabled="loading">
                                            <span v-if="loading">
                                                <i class="fas fa-spinner fa-spin"></i> Cargando...
                                            </span>
                                            <span v-else>Guardar</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </panel>
                    </div>
                </div>
            </div>

            <template #modal-footer>

            </template>

        </b-modal>

        <!-- bottom left vue-notification -->
        <notifications group="top-right" position="top right" :speed="1000" />
    </div>
</template>

<style>
.btnBuscar {
    display: flex;
    justify-content: flex-end;
    /* Mueve el botón a la derecha */
    padding: 10px;
}
</style>

<script>
import axios from "axios";
import moment from 'moment';
import {
    DxDataGrid, DxFormat,
    DxPaging, DxPager, DxScrolling, DxColumn, DxExport, DxSelection, DxGroupPanel, DxGrouping, DxHeaderFilter, DxFilterRow, DxSearchPanel,
} from 'devextreme-vue/data-grid';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';

// import EstatusCell from './EstatusCell.vue';
// Our demo infrastructure requires us to use 'file-saver-es'. We recommend that you use the official 'file-saver' package in your applications.
import { exportDataGrid } from 'devextreme/excel_exporter';

export default {
    mounted: function () {
        //debugger; // eslint-disable-line no-debugger
        var userSetting = JSON.parse(localStorage.getItem('userSettings'));
        this.userSetting = userSetting;
        console.log(this.userSetting);
    },
    data() {
        return {
            showHeaderFilter: true,
            loading: false,
            userSetting: undefined,
            EmpresaSeleccionada: null,
            ReporteGetAccruals: [],
            textoBotonBuscar: "Buscar",
            Empresas: [
                {
                    Nombre: "RCH",
                    ProgramID: 53663,
                    BrandID: 53663
                },
                {
                    Nombre: "USF",
                    ProgramID: 52614,
                    BrandID: 52614
                }
            ],
            MemberInfo: {
                CardNumber: "",
                FirstName: "",
                LastNamePaternal: "",
                Cliente: "",
                CurrentBalance: 0.0,
                BalanceOnHold: 0.0,
                ProductCredit: 0.0,
                PurchaseSegment: "",
                Producto: "",
                UserExtID: ""
            },
            Cardnumber: "",
            ProgramID: "",
            BrandID: "",
            Empresa: "",
            Estacion: "Company",
            Transaccion: "",
            ListrosCanjear: 0,
            Descuento: 0,
            Cantidad: 0.00,
            Total: 0.00,
            Precio: 0.00,
            Productos: [
                {
                    Nombre: "Gasolina 87 Octanos",
                    Value: 62,
                },
                {
                    Nombre: "Gasolina 91 Ocranos",
                    Value: 63,
                }
            ],
            ProductosSelect: 0,
            Ticket: {
                TipoPago: "",
                Transaccion: "",
                Turno: "",
                Fecha: "",
                Hora: "",
                Bomba: "",
                Total: "",
                PDF: undefined,
                Detalle: [
                    {
                        Transaccion: 0,
                        Producto: 0,
                        Cantidad: 0.00,
                        Descripcion: "",
                        Precio: 0.00,
                        ValorUnitario: 0.00,
                        Subtotal: 0.00,
                        IVA: 0.00,
                        IEPS: 0.00,
                        Total: 0.00,
                        CuotaIEPS: 0.00,
                        TasaIVA: 0.00,
                        ClaveProdServ: "",
                        ClaveUnidad: "",
                        Unidad: "",
                        Nuevo: false,
                        Periferico: false,
                        JsonPeriferico: null
                    }
                ]
            },
            cantidadMinima: 0,
            Archivo: {
                base64: '',
            },
            pdfBase64Resend: undefined,
            colorpicker: {
                color1: "rgb(135,83,222,0.8)",
                color2: "rgb(52,143,226)",
            },
            sliderDefault: {
                value: 9,
                max: 25,
            },
            sliderLabel: {
                value: "2018-10-08",
                width: "80%",
                tooltip: "always",
                disabled: false,
                piecewise: true,
                piecewiseLabel: true,
                style: {
                    marginLeft: "10%",
                },
                data: ["2016-10-05", "2016-10-06", "2016-10-07"],
            },
            sliderInterval: {
                lazy: true,
                interval: 5,
                max: 25,
                piecewise: true,
            },
            sliderFormatter: {
                value: [0, 96],
                min: 0,
                max: 500,
                disabled: false,
                show: true,
                useKeyboard: true,
                tooltip: "always",
                formatter: "¥{value}",
                mergeFormatter: "¥{value1} ~ ¥{value2}",
            },
            sliderFixedRange: {
                value: [45, 65],
                min: 0,
                max: 100,
                interval: 1,
                fixed: true,
                processDragable: true,
            },
            tagsArray: ["tags1", "tags2"],
            date: new Date(),
            options: {
                format: "DD/MM/YYYY",
                useCurrent: false,
            },
            form: {
                time: null,
                startDate: null,
                endDate: null,
            },
            configs: {
                timePicker: {
                    format: "LT",
                    useCurrent: false,
                },
                start: {
                    format: "DD/MM/YYYY",
                    useCurrent: false,
                    showClear: true,
                    showClose: true,
                    minDate: new Date(),
                    maxDate: false,
                },
                end: {
                    format: "DD/MM/YYYY",
                    useCurrent: false,
                    showClear: true,
                    showClose: true,
                    minDate: new Date(),
                },
            },
        };
    },
    watch: {
        EmpresaSeleccionada(value) {
            console.log(value);
            this.ProgramID = value.ProgramID;
            this.BrandID = value.BrandID;
            this.Empresa = value.Nombre;
        },
        ListrosCanjear(canje) {

            this.Ticket.Detalle.forEach(item => {
                if ([62, 63, 64].includes(item.Producto)) {

                    if (item.Producto === 64) {
                        this.alertMessage = "No se puede canjear en cargas de Diesel";
                        this.alertTitle = "Aviso";
                        this.show("top-right", "warn");
                        this.loading = false;
                        return;
                    } else {
                        var oper = item.Precio * canje;

                        this.Descuento = oper;
                        this.cantidadMinima = item.Cantidad;
                    }
                }
            });

        },
        Cantidad() {
            this.CalcularTotal();
        },
        Precio() {
            this.CalcularTotal();
        }
    },
    components: {
        DxScrolling,
        DxPager,
        DxPaging,
        DxHeaderFilter,
        DxSearchPanel,
        DxGroupPanel,
        DxGrouping,
        DxFormat,
        DxDataGrid, DxColumn, DxExport, DxSelection, DxFilterRow,
        // , EstatusCell
    },
    methods: {
        CalcularTotal() {
            var total = this.Cantidad * this.Precio;
            this.Total = total.toFixed(2);
        },
        formatTotal(e) {

        },

        limpiar() {
            this.Cardnumber = "";
            this.EmpresaSeleccionada = "";
            this.ProgramID = "";
            this.BrandID = "";
            this.Estacion = "Company";
            this.Transaccion = "";
            this.ListrosCanjear = 0;
            this.Descuento = 0;
            this.Cantidad = 0.00;
            this.Precio = 0.00;
            this.Total = 0.00;
            this.ProductosSelect = '';
            this.MemberInfo = {
                CardNumber: "",
                FirstName: "",
                LastNamePaternal: "",
                Cliente: "",
                CurrentBalance: 0.0,
                BalanceOnHold: 0.0,
                ProductCredit: 0.0,
                PurchaseSegment: "",
                Producto: "",
                UserExtID: ""
            };

            this.Ticket = {
                TipoPago: "",
                Transaccion: "",
                Turno: "",
                Fecha: "",
                Hora: "",
                Bomba: "",
                Total: "",
                PDF: undefined,
                Detalle: [
                    {
                        Transaccion: 0,
                        Producto: 0,
                        Cantidad: 0.00,
                        Descripcion: "",
                        Precio: 0.00,
                        ValorUnitario: 0.00,
                        Subtotal: 0.00,
                        IVA: 0.00,
                        IEPS: 0.00,
                        Total: 0.00,
                        CuotaIEPS: 0.00,
                        TasaIVA: 0.00,
                        ClaveProdServ: "",
                        ClaveUnidad: "",
                        Unidad: "",
                        Nuevo: false,
                        Periferico: false,
                        JsonPeriferico: null
                    }
                ]
            };
        },
        descargarPDF() {

            debugger; // eslint-disable-line no-debugger
            var self = this;
            var filename = "Factura_Electronica.pdf";
            // The actual download
            var link = document.createElement("a");
            //link.href = window.URL.createObjectURL(blob);
            link.href = "data:application/pdf;base64," + self.pdfBase64Resend;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async GetCardNumberInfo() {
            this.loading = true;
            try {
                if (this.Cardnumber == '') {
                    this.alertMessage = "Debe ingresar el Cardnumber.";
                    this.alertTitle = "Error";
                    this.show("top-right", "error");
                    this.loading = false;
                    return;
                }

                if (this.Empresa == '') {
                    this.alertMessage = "Debe ingresar la empresa.";
                    this.alertTitle = "Error";
                    this.show("top-right", "error");
                    this.loading = false;
                    return;
                }

                const response = await axios.post("Lealtad/CardNumberInfo", {
                    Data: {
                        Cardnumber: this.Cardnumber,
                        ProgramId: this.ProgramID,
                        BrandId: this.BrandID,
                        Empresa: this.Empresa
                    }
                });
                if (response.data.Success) {
                    this.MemberInfo = response.data.response.MemberInfo[0];
                    this.MemberInfo.Cliente = this.MemberInfo.FirstName + ' ' + this.MemberInfo.LastNamePaternal;
                    console.log(this.MemberInfo);

                    switch (this.MemberInfo.PurchaseSegment) {
                        case '62':
                            this.MemberInfo.Producto = '87 Octanos';
                            break;

                        case '63':
                            this.MemberInfo.Producto = '91 Octanos';
                            break;
                        case '':
                            this.MemberInfo.Producto = '';
                            break;
                    }
                    this.loading = false;

                } else {
                    this.alertMessage = response.data.Message;
                    this.alertTitle = "Error";
                    this.show("top-right", "error");
                    this.limpiar();
                    this.loading = false;
                }
            } catch (e) {
                this.alertMessage = "Ocurrio un error";
                this.alertTitle = "Error";
                this.show("top-right", "error");
                this.limpiar();
                this.loading = false;
            }
        },
        async SetAumentoSaldo() {
            this.loading = true;
            try {

                if (this.Cardnumber == '') {
                    this.alertMessage = "Debe ingresar el Cardnumber.";
                    this.alertTitle = "Error";
                    this.show("top-right", "error");
                    this.loading = false;
                    return;
                }

                if (this.Cantidad == undefined || this.Cantidad == null || this.Cantidad == '' || this.Cantidad == 0) {
                    this.alertMessage = "Debe ingresar Cantidad.";
                    this.alertTitle = "Error";
                    this.show("top-right", "error");
                    this.loading = false;
                    return;
                }

                if (this.Precio == undefined || this.Precio == null || this.Precio == '' || this.Precio == 0) {
                    this.alertMessage = "Debe ingresar Precio.";
                    this.alertTitle = "Error";
                    this.show("top-right", "error");
                    this.loading = false;
                    return;
                }

                if (this.Estacion == '') {
                    this.alertMessage = "Debe ingresar Estacion.";
                    this.alertTitle = "Error";
                    this.show("top-right", "error");
                    this.loading = false;
                    return;
                }

                if (this.ProductosSelect == '' || this.ProductosSelect == null || this.ProductosSelect == undefined) {
                    this.alertMessage = "Debe ingresar Producto.";
                    this.alertTitle = "Error";
                    this.show("top-right", "error");
                    this.loading = false;
                    return;
                }

                var data = {
                    Estacion: 0, // fijo
                    Gasolinera: 0, // fijo
                    Bomba: 0, // fijo
                    Total: this.Total, // se calcula
                    IdTipoPago: 0, // fijo
                    CardNumber: this.Cardnumber, // valor ingresado
                    NoEmpleado: 0, // fijo
                    Vendedor: "", // fijo
                    Usuario: this.userSetting.Usuario, // usuario logueado
                    ProgramId: this.ProgramID, // respuesta del Carnumber
                    BrandId: this.BrandID, // respuesta del Carnumber
                    Empresa: this.EmpresaSeleccionada.Nombre, // seleccionada por el usuario
                    Detalle: [
                        {
                            Producto: this.ProductosSelect.Value, // id del producto seleccionado
                            Cantidad: this.Cantidad, // ingresada por el usuario
                            Descripcion: this.ProductosSelect.Nombre, // texto del combo producto
                            Precio: this.Precio, // ingresado por el usuario
                            Total: this.Total// se calcula
                        }
                    ]
                };

                const response = await axios.post("Lealtad/AccrualD", {
                    data
                });
                if (response.data.Success) {
                    var resp = response.data.response
                    this.alertMessage = response.data.Message;
                    this.alertTitle = "Correcto";
                    this.show("top-right", "Success");
                    this.limpiar();
                    this.search();
                    this.$bvModal.hide('modalDialogVisor');

                    this.loading = false;
                } else {
                    this.alertMessage = response.data.Message;
                    this.alertTitle = "Error";
                    this.show("top-right", "error");
                    this.loading = false;
                }
            } catch (e) {
                this.alertMessage = "Ocurrio un error";
                this.alertTitle = "Error";
                this.show("top-right", "error");
                this.loading = false;
            }
        },

        async openModalVisor(data) {
            var self = this;
            this.limpiar();
            self.loading = true;

            try {
                this.$bvModal.show('modalDialogVisor');

                self.loading = false;

            } catch (e) {
                self.loading = false;
                self.alertMessage = e;
                self.alertTitle = "Error";
                self.show('top-right', 'error');
            }
        },

        onStartChange(e) {
            this.$set(this.configs.end, "minDate", e.date || null);
        },
        onEndChange(e) {
            this.$set(this.configs.start, "maxDate", e.date || null);
        },
        show(group, type = '') {
            const text = this.alertMessage;
            this.$notify({
                group,
                title: this.alertTitle,
                text,
                type,
                data: {
                    randomNumber: Math.random()
                }
            })
        },
        clean(group) {
            this.$notify({ group, clean: true })
        },
        swalNotification(swalType) {
            var btnClass = (swalType == 'error') ? 'danger' : swalType;
            btnClass = (swalType == 'question') ? 'primary' : btnClass;
            this.$swal({
                title: 'Are you sure?',
                text: 'You will not be able to recover this imaginary file!',
                type: swalType,
                showCancelButton: true,
                buttonsStyling: false,
                confirmButtonText: swalType.charAt(0).toUpperCase() + swalType.substr(1).toLowerCase(),
                cancelButtonText: 'Cancel',
                confirmButtonClass: 'btn me-5px btn-' + btnClass + '',
                cancelButtonClass: 'btn btn-default',
            })
        },
        onExporting(e) {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('ReporteCorePay');

            exportDataGrid({
                component: e.component,
                worksheet: worksheet,
                autoFilterEnabled: true
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ReporteCorePay.xlsx');
                });
            });
            e.cancel = true;
        },
        async search() {
            //debugger; // eslint-disable-line no-debugger
            var self = this;
            self.textoBotonBuscar = "Buscando...";
            try {

                const response = await axios.get('Lealtad/GetAccrualsD', {
                    "Data": {

                    }
                }
                );

                //debugger; // eslint-disable-line no-debugger
                if (response.data.Success) {

                    if (response.data.response.length == 0) {
                        this.alertMessage = "No se erncontro información del día especificado.";
                        this.alertTitle = "Error";
                        this.show('top-right', 'error');
                        this.ReporteGetAccruals = [];
                    } else {
                        self.ReporteGetAccruals = response.data.response;

                        for (var r = 0; r < self.ReporteGetAccruals.length; r++) {
                            if (self.ReporteGetAccruals[r].nb_resp == 'Aprobado') {
                                self.ReporteGetAccruals[r].importeReal = self.ReporteGetAccruals[r].nu_importe;
                            } else {
                                self.ReporteGetAccruals[r].importeReal = "0.00";
                            }

                        }
                    }
                } else {
                    this.ReporteGetAccruals = [];
                    console.log("error")
                    this.alertMessage = response.data.Message;
                    this.alertTitle = "Error";
                    this.show('top-right', 'error');
                }

                this.textoBotonBuscar = "Buscar";
            } catch (e) {
                this.ReporteGetAccruals = [];
                this.alertMessage = "Ocurrió un error";
                this.alertTitle = "Error";
                this.show('top-right', 'error');
                //this.alert = true;
                //this.error = 'Invalid email/password';
            }
        }

    },
};
</script>